import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { useAuth } from "./context/AuthContext";
import CouponGenerator from "./components/CouponGenerator";
import CouponList from "./components/CouponList";
import CouponApplicator from "./components/CouponApplicator";
import { AppBar, Toolbar, Typography, Button, Container, Box, Paper, colors } from "@mui/material";
import PhoneAuth from "./components/PhoneAuth";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { app } from "./firebase";

const theme = createTheme({
	palette: {
		primary: {
			main: colors.deepOrange[500],
		},
	},
});

console.log(app.options.projectId);
console.log(process.env);

function Navigation() {
	const { user, logout } = useAuth();

	return (
		<AppBar position="static">
			<Toolbar>
				<Typography variant="h6" component={Link} to="/" sx={{ flexGrow: 1, textDecoration: "none", color: "inherit" }}>
					Coupon Manager {app.options.projectId} {process.env.REACT_APP_ENVIRONMENT === "production" ? "Prod" : "Development"}
				</Typography>
				{user ? (
					<Box>
						<Button color="inherit" component={Link} to="/generate" sx={{ mr: 1 }}>
							Generate
						</Button>
						<Button color="inherit" component={Link} to="/list" sx={{ mr: 1 }}>
							List
						</Button>
						{/* <Button color="inherit" component={Link} to="/apply" sx={{ mr: 1 }}>
							Apply
						</Button> */}
						<Button color="inherit" onClick={logout}>
							Logout
						</Button>
					</Box>
				) : (
					<Button color="inherit" component={Link} to="/phone-auth">
						Sign In
					</Button>
				)}
			</Toolbar>
		</AppBar>
	);
}

function App() {
	return (
		<AuthProvider>
			<ThemeProvider theme={theme}>
				<Router>
					<Box>
						<Navigation />
						<Paper sx={{ paddingLeft: 3, paddingRight: 3 }}>
							<Routes>
								<Route path="/phone-auth" element={<PhoneAuth />} />
								<Route path="/generate" element={<CouponGenerator />} />
								<Route path="/list" element={<CouponList />} />
								<Route path="/apply" element={<CouponApplicator />} />
								<Route path="/" element={<CouponList />} />
							</Routes>
						</Paper>
					</Box>
				</Router>
			</ThemeProvider>
		</AuthProvider>
	);
}

export default App;
